import { Dictionary } from '../Wrapper';

export const section_color: Dictionary<string> = {
    0: '#677be9',
    1: '#809798',
    2: '#0E90E9',
    3: '#DE7324',
    4: '#E13A1C',
    5: '#00000',
};

export const color_labels: Dictionary<string> = {
    1: 'soma',
    2: 'axon',
    3: 'basal',
    4: 'apicical',
};

// export const neuron_color = '#00000';
export const selected_color = 'green';
